import { render, staticRenderFns } from "./distributorCode.vue?vue&type=template&id=5d4af110"
import script from "./distributorCode.vue?vue&type=script&lang=js"
export * from "./distributorCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports